export class LoggedUserInfoViewModel {
  public id: number;
  public email: string;
  public lastName: string;
  public firstName: string;
  
  constructor(init?: Partial<LoggedUserInfoViewModel>){
    Object.assign(this, init);
  }
}